import { encodedApi, plainApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const fileUploaderApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    imageUpload: builder.mutation({
      query: ({ file, mockedType }) => {
        const fd = new FormData();
        fd.append('file', file, file.name);

        return {
          url: plainApi(),
          method: 'POST',
          body: fd,
        };
      },
      transformResponse: (response, meta, arg) => {
        return { ...response.data[0].file, mockedType: arg.mockedType };
      },
      invalidatesTags: ['FileUpload']
    }),

    fileUpload: builder.mutation({
      query: (file) => {
        const fd = new FormData();
        fd.append('file', file, file.name);

        return {
          url: encodedApi(),
          method: 'POST',
          body: fd,
        };
      },
      transformResponse: (response) => response.data,
      invalidatesTags: ['FileUpload']
    })
  }),
  overrideExisting: false,
});

export const {
  useImageUploadMutation,
  useFileUploadMutation,
} = fileUploaderApiSlice;
